/**
 * Picks v2 or v1 of the dashboard based on the redesign flag.
 * Same pattern as SessionsPageSwitch / LoginSwitch.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import DashboardPage   from './DashboardPage';
import DashboardPageV2 from './DashboardPageV2';

export default function DashboardPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? DashboardPageV2 : DashboardPage;
  return <Component {...props} />;
}
